(function () {
  var form = document.querySelector('form[data-product-form]');
  var thumbs = document.querySelector('[data-color-thumbs]');
  if (!form) return;
  var fs = Array.prototype.find.call(form.querySelectorAll('fieldset[data-option]'), function (f) {
    var l = f.querySelector('legend');
    var t = l ? l.textContent.trim().toLowerCase() : '';
    return t === 'color' || t === 'colour';
  });
  if (!fs) return;
  var legend = fs.querySelector('legend');
  var base = legend.textContent.trim();

  function sync() {
    var c = fs.querySelector('input:checked');
    if (!c) return;
    legend.innerHTML = base + ': <span class="sw-name">' + c.value + '</span>';
    if (!thumbs) return;
    var first = null;
    thumbs.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      var tc = t.dataset.color || '';
      var show = !tc || tc === c.value;
      t.hidden = !show;
      if (show && !first && tc) first = t;
    });
    if (first) first.click();
  }
  fs.querySelectorAll('input').forEach(function (i) { i.addEventListener('change', sync); });
  var c0 = fs.querySelector('input:checked');
  if (c0) legend.innerHTML = base + ': <span class="sw-name">' + c0.value + '</span>';
})();
